import PropTypes from 'prop-types';
import React from 'react';
import RenderCardContent from './RenderCardContent';
import RenderCardFooter from './RenderCardFooter';
import { CardImage } from '../styles';

export default function RenderRepoCard({ cardData, type }) {
  const { openGraphImageUrl } = cardData || {};
  return (
    <>
      <CardImage
        alt="gallery"
        className="inset-0 w-full h-full object-cover object-center"
        src={openGraphImageUrl}
        height={type === 'list' ? null : '550px'}
        type={type}
      />
      <RenderCardContent contentData={cardData} type={type} />
      <RenderCardFooter footerData={cardData} type={type} />
    </>
  );
}

RenderRepoCard.propTypes = {
  cardData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  type: PropTypes.string.isRequired,
};
